const projectCreationRoot = `/project-creation`;

const navConstants = {
  auth: {
    login: '/login',
    callback: '/callback',
    deepLink: '/deep-link',
    logout: '/logout',
    unavailable: '/unavailable',
  },
  reports: {
    viewInvoices: '/reports/invoices',
    conciergeReports: '/customreports',
  },
  str: {
    baseSTR: '/str',
    viewSTR: '/str/view',
  },
  projectCreation: {
    serviceAgreement: `${projectCreationRoot}/service-agreement`,
    createProject: `${projectCreationRoot}/create-project`,
    hotLeadsForm: `${projectCreationRoot}/hot-leads-form`,
    hotLeadsFormSuccess: `${projectCreationRoot}/hot-leads-form-success`,
    progressDetail: `${projectCreationRoot}/progress-detail`
  },
};

export default navConstants;
